const { types, referenceTypes, uiTypes } = require("../utils/types");
const { validatorTypes } = require("../utils/validatorTypes");

const obj = {
  tableName: "contactus_info",
  read: true,
  create: true,
  edit: true,
  delete: true,
  comments: false, //for enabiling comments on view and edit
  references: [],
  columns: [
    {
      name: "id",
      type: types.UUID,
      allowNull: false,
      defaultValue: types.UUIDV4,
      primaryKey: true,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },

    {
      name: "title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [validatorTypes.string, validatorTypes.required],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "url",
      type: types.STRING,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.url, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },

    {
      name: "enabled",
      type: types.ENUM,
      allowNull: false,
      defaultValue: "disabled",
      enumValues: ["enabled", "disabled"],
      ui: {
        type: uiTypes.DROPDOWN,
        validation: [validatorTypes.string, validatorTypes.optional],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "createdAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        // added for ui
        type: uiTypes.DATE, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "updatedAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        // added for ui
        type: uiTypes.DATE, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "deletedAt",
      type: types.DATE,
      allowNull: true,
      defaultValue: null,
      read: false,
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: false,
        create: false,
        edit: false,
      },
    },
  ],
};
module.exports = obj;
